import type { UrlUpdateType } from 'use-query-params';

import {
  RESUME,
  COVER_LETTER,
  SELECTION_CRITERIA,
} from 'src/constants/attachmentTypes';
import { JOB_APPLICATION_TAB } from 'src/constants/tabs';
import type { IJobApplication } from 'src/stores/JobApplicationStore/JobApplication';

import { transformProfileToComponentProps } from '../../Profile/service/transformProfile';
import type { DetailTabSelectOption } from '../DetailsTabView';

export const getDetailTabs = (
  jobApplication: IJobApplication,
  isMobile: boolean,
  setTabQueryParam: (
    tab: JOB_APPLICATION_TAB,
    updateType: UrlUpdateType,
  ) => void,
) => {
  const {
    attachmentsStore,
    candidateStore,
    prospectEmailStore,
    profile,
    roleRequirements,
  } = jobApplication;
  const tabs: DetailTabSelectOption[] = [];
  const hasProfile = profile && transformProfileToComponentProps(profile);
  const hasRoleRequirements = roleRequirements.length > 0;
  if (hasProfile || hasRoleRequirements) {
    tabs.push({
      name: 'Profile',
      value: JOB_APPLICATION_TAB.PROFILE,
    });
  }

  if (!isMobile) {
    const attachments = attachmentsStore.applicationDocuments;

    const resume = attachments.find(
      (attachment) => attachment.type === RESUME.type,
    );
    if (resume) {
      tabs.push({
        name: 'Resumé',
        value: JOB_APPLICATION_TAB.RESUME,
        attachment: resume,
      });
    }

    const coverLetter = attachments.find(
      (attachment) => attachment.type === COVER_LETTER.type,
    );

    if (coverLetter) {
      tabs.push({
        name: 'Cover Letter',
        value: JOB_APPLICATION_TAB.COVER_LETTER,
        attachment: coverLetter,
      });
    }

    const selectionCriteria = attachments.find(
      (attachment) => attachment.type === SELECTION_CRITERIA.type,
    );
    if (selectionCriteria) {
      tabs.push({
        name: 'Selection Criteria',
        value: JOB_APPLICATION_TAB.SELECTION_CRITERIA,
        attachment: selectionCriteria,
      });
    }
  }

  if (candidateStore.previousApplicationCount > 0) {
    tabs.push({
      name: 'Previous Applications',
      counts: candidateStore.previousApplicationCount,
      value: JOB_APPLICATION_TAB.PREVIOUS_APPLICATIONS,
    });
  }

  tabs.push({
    name: 'Emails',
    value: JOB_APPLICATION_TAB.EMAILS,
    counts: prospectEmailStore.emailCount,
  });

  tabs.push({
    name: 'Notes & Attachments',
    value: JOB_APPLICATION_TAB.NOTES_ATTACHMENTS,
    counts: jobApplication.noteAttachmentCount,
  });

  if (!tabs.find((x) => x.value === jobApplication.selectedTabInDetailView)) {
    jobApplication.selectTabInDetailView(tabs[0].value);
    setTabQueryParam(tabs[0].value, 'replaceIn');
  }

  return tabs;
};
